import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="bg-brand-dark text-white mt-16">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          <div>
            <img
              src="https://customer-assets-lqy194kg.emergentagent.net/job_outils-depot/artifacts/1d0e5f454a2fc444_BATIPRODEAL_logo_vertical_transparent.png"
              alt="BATIPRODEAL"
              className="h-24 w-auto mb-4"
            />
            <p className="text-sm text-gray-300">
              Votre spécialiste en ligne pour tous vos articles de bricolage.
            </p>
            <p className="text-sm text-gray-300 mt-2">www.batiprodeal.com</p>
          </div>
          <div>
            <h4 className="font-semibold mb-4">Produits</h4>
            <ul className="space-y-2 text-sm text-gray-300">
              <li>
                <Link to="/products?category=outils-electriques" className="hover:text-brand-orange">
                  Outils électriques
                </Link>
              </li>
              <li>
                <Link to="/products?category=peinture" className="hover:text-brand-orange">
                  Peinture
                </Link>
              </li>
              <li>
                <Link to="/products?category=plomberie" className="hover:text-brand-orange">
                  Plomberie
                </Link>
              </li>
              <li>
                <Link to="/products?category=electricite" className="hover:text-brand-orange">
                  Électricité
                </Link>
              </li>
            </ul>
          </div>
          <div>
            <h4 className="font-semibold mb-4">Informations</h4>
            <ul className="space-y-2 text-sm text-gray-300">
              <li>
                <Link to="/about" className="hover:text-brand-orange">
                  À propos
                </Link>
              </li>
              <li>
                <Link to="/contact" className="hover:text-brand-orange">
                  Contact
                </Link>
              </li>
              <li>
                <Link to="/pages/livraison-retours" className="hover:text-brand-orange" data-testid="footer-link-livraison-retours">
                  Livraison
                </Link>
              </li>
              <li>
                <Link to="/pages/livraison-retours" className="hover:text-brand-orange" data-testid="footer-link-retours">
                  Retours
                </Link>
              </li>
            </ul>
          </div>
          <div>
            <h4 className="font-semibold mb-4">Support</h4>
            <ul className="space-y-2 text-sm text-gray-300">
              <li>
                <Link to="/contact" className="hover:text-brand-orange" data-testid="footer-link-contact">
                  FAQ
                </Link>
              </li>
              <li>
                <Link to="/pages/cgv" className="hover:text-brand-orange" data-testid="footer-link-garanties">
                  Garanties
                </Link>
              </li>
              <li>
                <Link to="/pages/cgv" className="hover:text-brand-orange" data-testid="footer-link-cgv">
                  CGV
                </Link>
              </li>
              <li>
                <Link to="/pages/mentions-legales" className="hover:text-brand-orange" data-testid="footer-link-mentions-legales">
                  Mentions légales
                </Link>
              </li>
              <li>
                <Link to="/pages/confidentialite" className="hover:text-brand-orange" data-testid="footer-link-confidentialite">
                  Politique de confidentialité
                </Link>
              </li>
            </ul>
          </div>
        </div>
        <div className="border-t border-gray-700 mt-8 pt-8 text-center text-sm text-gray-300">
          © {new Date().getFullYear()} BATIPRODEAL. Tous droits réservés.
        </div>
      </div>
    </footer>
  );
};

export default Footer;
